module.exports = __webpack_public_path__ + "static/media/yearly_financial_report_22_23.1b09ea14.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/general/yearly_financial_report_22_23.pdf
// module id = 211
// module chunks = 0